import { render, staticRenderFns } from "./ShopAdministration.vue?vue&type=template&id=d4f1cc1e&"
import script from "./ShopAdministration.vue?vue&type=script&lang=js&"
export * from "./ShopAdministration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports